import { styled } from 'styled-components'
import { motion } from 'framer-motion'

export const StyledHeader = styled.header(({ theme }) => `
  grid-area: header;
  /* position: sticky; */
  /* top: 0; */
  background: ${theme.colors.palette.darkBlack};
  font-size: 2.4em;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.palette.ghostWhite};
  // see StyledMain
  width: 100vw;  /* ensures it's bound to the viewport width */
  overflow-x: hidden;  /* prevents horizontal scroll */
  max-width: 100%;  /* prevents exceeding viewport width */
  box-sizing: border-box;  /* ensures padding doesn't extend it */
`)

export const StyledLogo = styled(motion.img)`
  height: 70%;
  margin: 0 0.6em;
  /* pointer-events: none; */
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`

export const StyledName = styled.p(({ theme }) => `
  margin: 0;
  color: ${theme.colors.palette.ghostWhite};
`)

export const StyledJobTitle = styled.p`
  margin: 0 0.6em 0 auto;
  font-size: 0.8em;
  color: ${({ theme }) => theme.colors.contrast.ghostWhite};

  @media (max-width: ${({ theme }) => theme.screens.small}) {
    visibility: hidden;
  }
`
